module.exports = __webpack_public_path__ + "media/images/themes/mandy/13-9c4bd79bc6d36216c6426b974760321f.png";